<template>
    <va-card :title="heading">
        <div class="row row-equal">
            <div class="flex md3">
                <va-select
                    label="Site"
                    v-model="selSite"
                    :options="selOptionsSites"
                    :searchable="true"
                    maxHeight="10"
                />
            </div>
            <div class="flex md1"></div>
            <div class="flex md1 text-right">Start</div>
            <div class="flex md2">
                <va-select
                v-model="selStartYear"
                :options="selOptionsYears"
                :noClear="true"
                maxHeight="10"
                />
            </div>
            <div class="flex md1">
                <va-select
                v-model="selStartMonth"
                :options="selOptionsMonths"
                :noClear="true"
                maxHeight="10"
                />
            </div>
        </div>
        <div class="row row-equal">
            <div class="flex md3">
                <va-checkbox v-model="includeInverters" class="mb-0" label="Include Inverters"/>
            </div>

            <div class="flex md1"></div>
            <div class="flex md1 text-right">End</div>
            <div class="flex md2">
                <va-select
                v-model="selEndYear"
                :options="selOptionsYears"
                :noClear="true"
                maxHeight="10"
                />
            </div>
            <div class="flex md1">
                <va-select
                v-model="selEndMonth"
                :options="selOptionsMonths"
                :noClear="true"
                maxHeight="10"
                />
            </div>
            <div class="flex md1">
          <va-button @click="loadData()">Load</va-button>
            </div>
            <div class="flex md2">
          <va-button @click="downloadData()" color="success" :disabled="csvDisabled">Download CSV</va-button>
            </div>
        </div>

        <div v-if="loading" class="hiq-spinner-div">
        <img class="hiq-spinner" src="/assets/rpspinnerb.png" />
        </div>

        <va-data-table
            :fields="fields"
            :data="listData"
            no-pagination
            v-if="!loading"
            >
            <template slot="actions" slot-scope="props">
                <va-popover :message="getStarMessage(props.rowData)" placement="top">
                    <va-button
                        flat small
                        :color="getStarColor(props.rowData)"
                        icon="fa fa-star"
                        @click="star(props.rowData)"
                        />
                </va-popover>

                <va-popover :message="`${$t('tables.edit')} ${props.rowData.fullName}`" placement="top">
                    <va-button flat small color="gray" icon="fa fa-pencil" />
                </va-popover>

                <va-popover :message="`${$t('tables.delete')} ${props.rowData.fullName}`" placement="top">
                    <va-button flat small color="gray" icon="fa fa-trash" />
                </va-popover>
            </template>
        </va-data-table>
    </va-card>
</template>

<script>
import hiqapi from '@/hiqapi/hiqapi'
import { zeroPad, formatDate } from '@/common'

export default {
  data() {
    return {
      listData: [],
      selOptionsYears: ['2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025'],
      selOptionsMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      selStartYear: '2021',
      selStartMonth: 'Jan',
      selEndYear: '2021',
      selEndMonth: 'Jan',
      includeInverters: false,

      selSite: null,

      siteList: [],
      loading: false,
      dataType: 'site', // or 'gateway'

      fields: [],
    }
  },
  computed: {
    heading() {
      switch (this.$route.name) {
        case 'reports-site-prod':
          return 'Site Production kWh'
        case 'reports-inverter-prod':
          return 'Inverter Production kWh'
        default:
          console.log('ERROR unknown route name ', this.$route.name)
      }
    },

    selOptionsSites() {
      let res = []
      if (!this.siteList) {
        return res
      }
      this.siteList.forEach(function(item) {
        if (item.gateways.length) {
          let gwSerial = item.gateways[0].serial
          res.push({ id: item.id, gwSerial: gwSerial, text: item.name })
        }
      })
      res.sort((a, b) => (a.text > b.text) ? 1 : -1)
      return res
    },
    csvDisabled() {
      return this.listData.length === 0
    },

  },
  methods: {
    setSiteData(newval) {
      console.log('RM setSITE data', newval)
      this.siteList = newval.items
    },
    setData(newval) {
      console.log('RM SET DATA: ', newval)
      this.listData = []
      if (newval.items.length === 0) {
        return
      }

      // No inverters is very simple
      if (this.dataType === 'site') {
        newval.items.forEach(item => this.listData.push({ date: formatDate(item.date), kwh: item.kwh }))
        this.fields = [{ name: 'date', title: 'Date', sortField: 'date', dataClass: 'text-right' },
          { name: 'kwh', title: 'kWh', sortField: 'kwh', dataClass: 'text-right' }]

        this.loading = false
        return
      }

      /// Inverters need to be processed

      let data = {} // data[date]
      let invIx = {} // invIx[inv_serial] = <index into data[date]>
      let nextIx = 0
      newval.items.forEach(item => {
        if (!(item.inv_serial in invIx)) {
          invIx[item.inv_serial] = nextIx
          nextIx++
        }

        if (!(item.date in data)) {
          data[item.date] = { date: formatDate(item.date) }
        }

        data[item.date][item.inv_serial] = item.kwh
      })

      this.listData = Object.values(data)
      this.listData.sort((a, b) => this.dateSortCmp(a.date, b.date))
      this.fields = [{ name: 'date', title: 'Date', sortField: 'date', dataClass: 'text-right' }]
      Object.keys(invIx).forEach(key => this.fields.push({ name: key, title: key, sortField: key, dataClass: 'text-right' }))
      this.loading = false
    },

    dateSortCmp(date1, date2) {
      // compare 2 string dates for sorting
      const bits1 = date1.split('/')
      const bits2 = date2.split('/')

      // year
      if (bits1[2] > bits2[2]) {
        return 1
      }
      if (bits1[2] < bits2[2]) {
        return -1
      }

      // month
      const m1 = parseInt(bits1[0])
      const m2 = parseInt(bits2[0])
      if (m1 > m2) {
        return 1
      }
      if (m1 < m2) {
        return -1
      }

      // day
      const d1 = parseInt(bits1[1])
      const d2 = parseInt(bits2[1])
      if (d1 > d2) {
        return 1
      }
      if (d1 < d2) {
        return -1
      }
      return -1
    },

    loadData() {
      this.loading = true
      console.log(`RM LOAD DATA ${this.selStartYear} ${this.selStartMonth} - ${this.selEndYear} ${this.selEndMonth}`)
      console.log(this.selSite)
      let sy = this.selStartYear
      let ey = this.selEndYear
      let sm = zeroPad(this.selOptionsMonths.indexOf(this.selStartMonth) + 1, 2)
      let em = zeroPad(this.selOptionsMonths.indexOf(this.selEndMonth) + 2, 2)

      if (em == 13) { // it rolled over into Jan of the next year
        em = 1;
        ey += 1;
      }

      let group = 'period'
      this.dataType = 'site'
      if (this.includeInverters) {
        group = 'both'
        this.dataType = 'gateway'
      }
      hiqapi.getcb(`/inverters/data?gw_serial=${this.selSite.gwSerial}&fields=kwh&group=${group}&res=1d&start_date=${sy}-${sm}-01&end_date=${ey}-${em}-01`, this.setData)

      // Array Production kWh [site]
      // gw_serial=2726&fields=kwh&group=period&res=1h&start_date=2021-02-01&end_date=2021-02-04
      // time kWh

      // Inverter Output Comparison kW
      // gw_serial=2726&fields=kwh&group=both&res=1h&start_date=2021-01-01&end_date=2021-02-05
      // time inv1-kW inv2-kW inv3-kW
    },
    genDownloadDataNoGws(data) {
      let csvRows = ['Date, Output (kWh)']
      data.forEach(item => csvRows.push(`${item.date},${item.kwh}`))
      return csvRows.join('\n')
    },

    genDownloadDataWithGws(data) {
      // Get all the inverters (they may not all appear in all rows)
      const cols = this.fields.map(i => i.name)
      let csvRows = []
      csvRows.push(cols)
      data.forEach(item => {
        let row = []
        cols.forEach(col => {
          if (col in item) {
            row.push(item[col])
          } else {
            row.push('')
          }
        })
        csvRows.push(row)
      })
      csvRows[0][0] = 'Date' // [cough cough]
      return csvRows.join('\n')
    },

    downloadData() {
      let csv = null
      if (this.includeInverters) {
        csv = this.genDownloadDataWithGws(this.listData)
      } else {
        csv = this.genDownloadDataNoGws(this.listData)
      }

      var uri
      if ((navigator.userAgent.indexOf('Chrome') !== -1) ||
            (navigator.userAgent.indexOf('Safari')) === -1) {
        uri = 'data:text/csv,' + encodeURIComponent(csv)
      } else {
        uri = 'data:application/ms-excel;filename=filename.csv,' + encodeURIComponent(csv)
      }
      var downloadLink = document.createElement('a')
      document.body.appendChild(downloadLink)
      var ts = new Date().getTime()
      downloadLink.download = 'SiteProduction_' + ts + '.csv'
      downloadLink.href = uri
      downloadLink.click()
      document.body.removeChild(downloadLink)
    },
  },

  mounted() {
    hiqapi.getcb('/sites?gw_details=true', this.setSiteData)

    let year = new Date().getFullYear().toString()
    this.selStartYear = year
    this.selEndYear = year

    let month = this.selOptionsMonths[ new Date().getMonth() ]
    this.selStartMonth = month
    this.selEndMonth = month
  },
}
</script>

<style lang="scss">
</style>
